import styles from "./FamilyMembers.module.scss";
import { DefaultSection } from "../../../../../common/components/common/DefaultSection";
import { Persona } from "../../../../../common/components/common/Persona/Persona";
import { IconButton } from "../../../../../common/components/button/iconButton/IconButton";
import { IconType } from "../../../../../common/icons/Icon";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import { UserWizardContents } from "../../../../administration/usersAdministration/userWizard/components/UserWizardContents";
import { useFamilyMembers } from "../hooks/useFamilyMembers";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { useAppContext } from "../../../../../AppContext";

interface IFamilyMembersTableProps {
  familyMembers?: ISelectFieldModel[] | null;
  familyId: number;
}

export const FamilyMembers = ({
  familyMembers,
  familyId,
}: IFamilyMembersTableProps) => {
  const { selectedStudio } = useAppContext();
  const {
    setShowNewUserDialog,
    handleSubmit,
    width,
    showNewUserDialog,
    isCreateRequestLoading,
  } = useFamilyMembers(familyId);

  if (!familyMembers) {
    return;
  }

  return (
    <>
      <DefaultSection
        title="Членове на семейството"
        tooltip="За премахване на членове, моля обърнете се към администратор на обекта."
        className={styles.root_section}
        headerClassName={styles.root_section_title}
        width={width}
        actionButton={
          <IconButton
            iconType={IconType.PlusIcon}
            onClick={() => setShowNewUserDialog(true)}
          />
        }
      >
        {familyMembers.map((member) => (
          <Persona
            className={styles.root_section_item}
            key={member.id}
            firstName={member.name}
            id={member.id}
          />
        ))}
      </DefaultSection>

      <AppDialog
        header="Добавяне на нов член на семейството"
        visible={showNewUserDialog}
        onHide={() => setShowNewUserDialog(false)}
        contentClassName={styles.dialog_content}
      >
        <UserWizardContents
          pageMode={"add"}
          additionalHandleSubmit={handleSubmit}
          customIsLoading={isCreateRequestLoading}
          customDisclaimerText="Ако някой от членовете на семейството вече има регистрация, моля, свържете се с член от екипът на обекта, за да го добави към семейството."
          portalFamilyMode
          showBirthDate={selectedStudio?.askForUserBirthdayOnRegistration}
        />
      </AppDialog>
    </>
  );
};
